// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCeRkDaiLb3xmm5vNSCgP2ctYpPlwFBenE",
  authDomain: "gestao-comissoes-sintanet.firebaseapp.com",
  projectId: "gestao-comissoes-sintanet",
  storageBucket: "gestao-comissoes-sintanet.firebasestorage.app",
  messagingSenderId: "204660934418",
  appId: "1:204660934418:web:fd56c05aee8f671242d5cb",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);